module.exports = __webpack_public_path__ + "static/media/japan_flag2.bdfc1603.png";